<template lang="pug">
.pagination-wrapper__container
  slot(
    name="content"
    :content="content"
    :headers="headers"
    :loading="loading"
  )
  slot(
    name="controls"
    :isFirstPage="isFirstPage"
    :isLastPage="pagination.isLastPage"
    :moveNext="moveNextPage"
    :movePrev="movePrevPage"
  )
    .pagination-wrapper__controls
      v-btn.pa-1.rounded-lg(
        @click="movePrevPage"
        min-width="auto"
        :disabled="isFirstPage"
      ): v-icon mdi-chevron-left
      v-btn.pa-1.rounded-lg(
        @click="moveNextPage"
        min-width="auto"
        :disabled="pagination.isLastPage"
      ): v-icon mdi-chevron-right
</template>

<script>
export default {
  name: 'LightPaginationWrapper',

  props: {
    method: {
      type: Function,
      required: true,
    },

    serializeData: {
      type: Function,
      default: (data) => data,
    },

    perPage: {
      type: [Number, String],
      default: 10,
    },
  },

  data() {
    return {
      content: [],
      offsetContent: [],
      headers: [],
      loading: false,

      pagination: {
        page: 1,
        isLastPage: false,
      },
    };
  },

  computed: {
    isFirstPage() {
      return this.pagination.page === 1;
    },
  },

  created() {
    this.callMethod();
  },

  methods: {
    async callMethod() {
      this.loading = true;
      const perPage = Number(this.perPage);
      const params = {
        page: this.pagination.page,
        'per-page': perPage,
        ltp: 1,
      };

      await this.$rHandler(
        this.method(params),
        ({ data, headers }) => {
          if (data.data.length < perPage) {
            this.pagination.isLastPage = true;
          } else {
            this.pagination.isLastPage = false;
          }
          if (!data.data.length && this.pagination.page > 1) {
            this.pagination.page -= 1;
          } else {
            this.content = data.data;
            this.headers = headers;
          }
        },
      );
      this.loading = false;
    },

    moveNextPage() {
      this.pagination.page += 1;
      this.callMethod();
    },

    movePrevPage() {
      this.pagination.page -= 1;
      this.pagination.isLastPage = false;
      this.callMethod();
    },

    reloadData() {
      if (this.pagination.page !== 1) {
        this.pagination.page = 1;
      }
      this.callMethod();
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination-wrapper {
  &__container {}
  &__controls {
    display: flex;
    justify-content: center;
    gap:8px;
    padding: 8px;
  }
}
</style>
